
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editTrailerProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"apiToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrailerProfileInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editTrailerProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"apiToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"apiToken"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"errors"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"result"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"trailerStyle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plannedMonthlyMileage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ebpmsActive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tpmsActive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"height"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"weight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"serviceInterval"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tailLift"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"moffetMounts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastService"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ownerDepotId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ebsValveType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"group"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vehicleType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vehicleMake"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vehicleGrossWeight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"operator"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tyreSize"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"axleMake"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"colour"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"year"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"suspensionMake"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"brakeSize"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lightingMake"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nextServiceDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastMotDoe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nextMotDoe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contract"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"placardPressure"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"extremeUnderinflationWarning"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"underinflationWarning"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastEbpmsReportDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ebpmsInterval"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tareWeight"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":864}};
    doc.loc.source = {"body":"mutation editTrailerProfile($apiToken: String!, $data: TrailerProfileInput!) {\n  editTrailerProfile(apiToken: $apiToken, data: $data) {\n    status\n    errors\n    result {\n      id\n      trailerStyle\n      vin\n      vor\n      plannedMonthlyMileage\n      ebpmsActive\n      tpmsActive\n      height\n      weight\n      serviceInterval\n      tailLift\n      moffetMounts\n      lastService\n      ownerDepotId\n      ebsValveType\n      group\n      vehicleType\n      vehicleMake\n      vehicleGrossWeight\n      operator\n      description\n      tyreSize\n      axleMake\n      colour\n      year\n      suspensionMake\n      brakeSize\n      lightingMake\n      nextServiceDate\n      lastMotDoe\n      nextMotDoe\n      contract\n      placardPressure\n      extremeUnderinflationWarning\n      underinflationWarning\n      lastEbpmsReportDate\n      ebpmsInterval\n      tareWeight\n  }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["editTrailerProfile"] = oneQuery(doc, "editTrailerProfile");
        
